import { loadDevMessages, loadErrorMessages } from "@apollo/client/dev";
import * as Sentry from "@sentry/react";

import { DEPLOY_ENV, DEV, RELEASE_HASH, SENTRY_DSN } from "./config";

//////////////////////////////////////////////////////////////////////////////
// Apollo                                                                   //
//////////////////////////////////////////////////////////////////////////////

if (DEV) {
  loadDevMessages();
  loadErrorMessages();
}

//////////////////////////////////////////////////////////////////////////////
// Sentry                                                                   //
//////////////////////////////////////////////////////////////////////////////

Sentry.init({
  dsn: SENTRY_DSN,
  environment: DEPLOY_ENV,
  release: RELEASE_HASH,
  // This sets the sample rate to be 1% on prod.
  // Note: For development is set to be 100%
  replaysSessionSampleRate: DEV ? 1 : 0.01,
  // If the entire session is not sampled, use the below sample rate to sample
  // sessions when an error occurs.
  replaysOnErrorSampleRate: 0.8,
  integrations: [
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
    Sentry.browserTracingIntegration(),
  ],
  // Adjusted for production to 25% to reduce the amount of data sent to Sentry
  tracesSampleRate: DEV ? 1 : 0.25,
  ignoreErrors: [
    "mce-visual-caret-hidden",
    "TypeError: Failed to fetch (suggestion",
  ],
});
